export default "__VITE_ASSET__DqJPX6_n__"